import { UserRoleE } from "../../models/enums";
import { RoutesE } from "../../routes/routesData";

type MenuItemsT = {
  link?: RoutesE;
  name: string;
  role?: UserRoleE[];
  globalAdminOnly?: boolean;
  items?: MenuItemsT[];
};

export const menuItems: MenuItemsT[] = [
  {
    link: RoutesE.HOME,
    name: "Home",
    role: [UserRoleE.DeliveryService],
  },
  {
    link: RoutesE.CAMPAIGNS,
    name: "Campaigns",
    role: [
      UserRoleE.GlobalAdmin,
      UserRoleE.GlobalAdminAndAdminContentManager,
      UserRoleE.AdvertisingAgency,
      UserRoleE.Broadcaster,
      UserRoleE.PostProduction,
      UserRoleE.Production,
      // DeliveryService excluded — they have no access to the cross-publisher list
      UserRoleE.MediaCompany,
    ],
  },
  {
    link: RoutesE.DELIVERIES,
    name: "Deliveries",
    role: [
      UserRoleE.GlobalAdmin,
      UserRoleE.GlobalAdminAndAdminContentManager,
      UserRoleE.AdvertisingAgency,
      UserRoleE.Broadcaster,
      UserRoleE.PostProduction,
      UserRoleE.Production,
      // DeliveryService excluded — they have no access to the cross-publisher list
      UserRoleE.MediaCompany,
    ],
  },
  {
    link: RoutesE.VERSIONS,
    name: "Versions",
    role: [
      UserRoleE.GlobalAdmin,
      UserRoleE.GlobalAdminAndAdminContentManager,
      UserRoleE.AdvertisingAgency,
      UserRoleE.Broadcaster,
      UserRoleE.PostProduction,
      UserRoleE.Production,
      // DeliveryService excluded — as for Campaigns / Deliveries (spec 49 D6)
      UserRoleE.MediaCompany,
    ],
  },
  {
    name: "Manage",
    items: [
      {
        link: RoutesE.MANAGE_CLIENTS,
        name: "Clients",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_USERS,
        name: "Users",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_CAMPAIGNS,
        name: "Campaigns",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_PROJECTS,
        name: "Projects",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_PROJECT_FILES,
        name: "Versions",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_ADVERTISERS,
        name: "Advertisers",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_BRANDS,
        name: "Brands",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_MARKET_CATEGORIES,
        name: "Market categories",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_PRODUCTION_COMPANIES,
        name: "Production Companies",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_NEW_SERVICE_PACKAGES,
        name: "New Service Packages",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_SERVICE_PACKAGES,
        name: "Service Packages",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_FTP_SETTINGS,
        name: "FTP Settings",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_MAIL_TEMPLATES,
        name: "System Mail Templates",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_HOUSE_NUMBERS,
        name: "House Numbers",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_TRANSLATES,
        name: "Translations",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_GLOBAL_SETTINGS,
        name: "Global Settings",
        role: [UserRoleE.GlobalAdmin],
      },
      {
        link: RoutesE.MANAGE_VIDEO_GUIDES,
        name: "Video Guides",
        role: [UserRoleE.GlobalAdmin],
      },
    ],
    role: [UserRoleE.GlobalAdmin],
  },
  {
    name: "Manage",
    items: [
      {
        link: RoutesE.MANAGE_CAMPAIGNS,
        name: "Campaigns",
        role: [UserRoleE.GlobalAdminAndAdminContentManager],
      },
      {
        link: RoutesE.MANAGE_PROJECT_FILES,
        name: "Versions",
        role: [UserRoleE.GlobalAdminAndAdminContentManager],
      },
      {
        link: RoutesE.MANAGE_ADVERTISERS,
        name: "Advertisers",
        role: [UserRoleE.GlobalAdminAndAdminContentManager],
      },
      {
        link: RoutesE.MANAGE_BRANDS,
        name: "Brands",
        role: [UserRoleE.GlobalAdminAndAdminContentManager],
      },
      {
        link: RoutesE.MANAGE_MARKET_CATEGORIES,
        name: "Market Categories",
        role: [UserRoleE.GlobalAdminAndAdminContentManager],
      },
      {
        link: RoutesE.MANAGE_HOUSE_NUMBERS,
        name: "House Numbers",
        role: [UserRoleE.GlobalAdminAndAdminContentManager],
      },
    ],
    role: [UserRoleE.GlobalAdminAndAdminContentManager],
  },
  {
    link: RoutesE.MANAGE_DELIVERY_ORDERS,
    name: "Delivery Orders",
    globalAdminOnly: true,
  },
  {
    link: RoutesE.MANAGE_RE_DELIVERY_ORDERS,
    name: "Re-Delivery Orders",
    globalAdminOnly: true,
  },
  // {
  //     link: RoutesE.MANAGE_SUPPORT_MESSAGES,
  //     name: 'Support',
  //     role: [UserRoleE.GlobalAdmin],
  // },
  {
    name: "Support",
    items: [
      {
        link: RoutesE.SUPPORT_VIDEO_GUIDES,
        name: "Video Guides",
        role: [
          UserRoleE.AdvertisingAgency,
          UserRoleE.GlobalAdminAndAdminContentManager,
          UserRoleE.Broadcaster,
          UserRoleE.PostProduction,
          UserRoleE.Production,
          UserRoleE.DeliveryService,
          UserRoleE.MediaCompany,
        ],
      },
      {
        link: RoutesE.SUPPORT_TECHNICAL_INSTRUCTION,
        name: "Technical Instruction",
        role: [
          UserRoleE.AdvertisingAgency,
          UserRoleE.GlobalAdminAndAdminContentManager,
          UserRoleE.Broadcaster,
          UserRoleE.PostProduction,
          UserRoleE.Production,
          UserRoleE.DeliveryService,
          UserRoleE.MediaCompany,
        ],
      },
      {
        link: RoutesE.SUPPORT_CONTACT_US,
        name: "Contact Us",
        role: [
          UserRoleE.AdvertisingAgency,
          UserRoleE.GlobalAdminAndAdminContentManager,
          UserRoleE.Broadcaster,
          UserRoleE.PostProduction,
          UserRoleE.Production,
          UserRoleE.DeliveryService,
          UserRoleE.MediaCompany,
        ],
      },
      {
        link: RoutesE.POST_PRODUCTION_PRICE_CALC,
        name: "Price Calculator",
        role: [UserRoleE.PostProduction, UserRoleE.DeliveryService],
      },
    ],
    role: [
      UserRoleE.AdvertisingAgency,
      UserRoleE.GlobalAdminAndAdminContentManager,
      UserRoleE.Broadcaster,
      UserRoleE.PostProduction,
      UserRoleE.Production,
      UserRoleE.DeliveryService,
      UserRoleE.MediaCompany,
    ],
  },
  {
    link: RoutesE.MANAGE_LEADS,
    name: "Contacts",
    role: [UserRoleE.GlobalAdmin],
  },
  {
    link: RoutesE.REPORTS,
    name: "Reports",
    role: [
      UserRoleE.PostProduction,
      UserRoleE.AdvertisingAgency,
      UserRoleE.Broadcaster,
      UserRoleE.MediaCompany,
    ],
  },
  {
    link: RoutesE.SETTINGS,
    name: "Settings",
    role: [
      UserRoleE.AdvertisingAgency,
      UserRoleE.Broadcaster,
      UserRoleE.PostProduction,
      UserRoleE.Production,
      UserRoleE.GlobalAdminAndAdminContentManager,
      UserRoleE.DeliveryService,
      UserRoleE.MediaCompany,
    ],
  },
  {
    link: RoutesE.MANAGE_NEWSLETTERS,
    name: "Newsletters",
    globalAdminOnly: true,
  },
  {
    // Link + dropdown (spec 46): the label opens the General report; the children are the three
    // reports. Menu.tsx renders a parent that has BOTH `link` and `items` as a label anchor beside
    // its nested list. Labels are verbatim the in-page "Select report type" options
    // (pages/manage/VideoReport/VideoReport.tsx). Every child must repeat `globalAdminOnly` —
    // filterByRole drops a child that carries neither `role` nor `globalAdminOnly`.
    name: "Reports",
    link: RoutesE.REPORT_GENERAL,
    globalAdminOnly: true,
    items: [
      {
        name: "General Report",
        link: RoutesE.REPORT_GENERAL,
        globalAdminOnly: true,
      },
      {
        name: "Client Report",
        link: RoutesE.REPORT_CLIENT,
        globalAdminOnly: true,
      },
      {
        name: "Broadcasters - Inner campaigns",
        link: RoutesE.REPORT_BROADCASTERS_INNER,
        globalAdminOnly: true,
      },
    ],
  },
  // {
  //     link: RoutesE.ABOUT,
  //     name: 'About',
  // },
  {
    link: RoutesE.PROCESS,
    name: "Process",
  },
  {
    link: RoutesE.FEATURES,
    name: "Features",
  },
  {
    link: RoutesE.CONTACT_US,
    name: "Contact Us",
  },
];
